import StockDelete from './StockDelete'
export {StockDelete}
export default StockDelete
